(() => {
  document.addEventListener('click', (event) => {
    const detailButton = event.target.closest('[data-rmx-v7-tab-target]');
    if (!detailButton) return;

    const target = detailButton.dataset.rmxV7TabTarget;
    document.querySelector(`[data-rmx-tab-button="${target}"]`)?.click();

    detailButton.closest('.rmx-v7-product-detail-nav')
      ?.querySelectorAll('button')
      .forEach((button) => button.classList.toggle('is-active', button === detailButton));

    document.querySelector('.rmx-tabs-card')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
